import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import coupon from "@/view/coupon";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/coupon",
      meta: {
        title: "话费领取"
      }
    },
    {
      path: "/coupon",
      name: "coupon",
      component: coupon,
      meta: {
        title: "话费领取"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js